import { Spinner } from "@/components/ui/spinner";

export function ImageStripBusyOverlay() {
    return (
        <div className="absolute inset-0 flex items-center justify-center rounded-md bg-white/65">
            <Spinner className="size-5" />
        </div>
    );
}
